import React from 'react';

function Loader({ transitionStatus }: any) {
	return <div className={`loader${transitionStatus ? ` loader--${transitionStatus}` : ''}`} />;
}

export default Loader;
